export default class VideoBlock {
    constructor(container) {
        this.container = container;
        this.wrapper = container.querySelector('.container');
        this.playButton = container.querySelector('.video-block__play-button');

        if (!this.wrapper || !this.playButton) {
            return;
        }

        this.playButton.addEventListener('click', () => this.loadVideo());
    }

    loadVideo() {
        const youtubeId = this.wrapper.dataset.youtubeId;
        const hbplayId = this.wrapper.dataset.hbplayId;

        let iframeSrc = '';

        if (youtubeId) {
            iframeSrc = `https://www.youtube.com/embed/${youtubeId}?autoplay=1&rel=0`;
        } else if (hbplayId) {
            iframeSrc = `https://play.hb.se/embed/secure/iframe/entryId/${hbplayId}`;
        }

        if (!iframeSrc) {
            return;
        }

        const iframe = document.createElement('iframe');
        iframe.src = iframeSrc;
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('title', 'Embedded video player');

        this.wrapper.innerHTML = '';
        this.wrapper.appendChild(iframe);
    }
}
